<template>
  <div>
    <v-snackbar
      v-model="show"
      :timeout="0"
      right
      top
      vertical
    >
      网页已发布新版本，是否现在刷新？
      <v-btn
        color="pink"
        flat
        @click="reload"
      >
        刷新
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      show: false,
      timer: null,
      appSrc: ''
    }
  },
  async mounted () {
    this.appSrc = await this.getAppSrc()
    this.timer = setInterval(this.checkUpdate, 30000) // 30秒检测一次
  },
  destroyed () {
    clearInterval(this.timer)
  },
  methods: {
    async getAppSrc () {
      const { data } = await axios.get('/static/version.html?' + Date.now())
      return data
    },
    async checkUpdate () {
      if (this.appSrc !== await this.getAppSrc()) {
        this.show = true
      }
    },
    reload () {
      location.reload()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/_layout/CheckUpdate.vue